"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _core = require("@commerce-ui/core2");
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _router = require("next/router");
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _LanguageProvider = require("@deosite/api/hooks/common/LanguageProvider");
var _RouteContext = require("@deosite/lib/RouteContext");
var _hasStoreAdditionalFunctionalities = _interopRequireDefault(require("@deosite/helpers/hasStoreAdditionalFunctionalities"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var textToShow = function textToShow(infoText, showMore) {
  var isTextTooLong = !infoText.length <= global.__appConfig__.cookieNoticeMaxLength;
  return isTextTooLong ? "".concat(infoText.slice(0, global.__appConfig__.cookieNoticeMaxLength) + "\u2026 <span>".concat(showMore, "</span>")) : infoText;
};
var CookieNotice = function CookieNotice(props) {
  var onAcceptButtonClick = props.onAcceptButtonClick,
    onManageOptionsButtonClick = props.onManageOptionsButtonClick,
    confirmButton = props.confirmButton,
    manageButton = props.manageButton,
    domain = props.domain;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var translations = {
    acceptAllCookies: (0, _langLibrary["default"])("Accept all cookies"),
    cookiesPanelTitle: (0, _langLibrary["default"])("Manage cookie settings"),
    cookieNotice: (0, _langLibrary["default"])("Cookie notice", {
      domain: domain
    }),
    showMore: (0, _langLibrary["default"])("show more")
  };
  var router = (0, _router.useRouter)();
  var infoText = translations.cookieNotice;
  var manageOptionsButtonLabel = translations.cookiesPanelTitle;
  var _useState = (0, _react.useState)(null),
    text = _useState[0],
    setText = _useState[1];
  (0, _react.useEffect)(function () {
    setText(textToShow(infoText, translations.showMore));
  }, []);
  var confirmButtonDisplay = /*#__PURE__*/_react["default"].cloneElement(confirmButton, {
    onClick: onAcceptButtonClick
  }, translations.acceptAllCookies);
  var manageButtonDisplay = /*#__PURE__*/_react["default"].cloneElement(manageButton, {
    onClick: onManageOptionsButtonClick
  }, translations.cookiesPanelTitle);
  return __jsx(_Box["default"], {
    sx: {
      background: "white",
      boxShadow: "rgba(0, 0, 0, 0.16) 0px 4px 16px",
      borderRadius: "5px",
      p: (0, _core.lin)("s8", "s9"),
      display: "flex",
      flexDirection: ["column", null, null, "row", null, null],
      justifyContent: "space-between"
    }
  }, __jsx(_Box["default"], {
    sx: {
      font: "body2",
      maxHeight: "60vh",
      overflow: ["scroll", null, null, "hidden"],
      maxWidth: ["100%", null, null, "80%", "85%", "90%"],
      pr: [null, null, null, "s5", null, null],
      "-webkit-text-size-adjust": "100%",
      color: "main",
      a: {
        color: "active",
        ":focus": {
          outline: "none"
        }
      },
      span: {
        color: "active",
        cursor: "pointer"
      }
    }
  }, __jsx(_Box["default"], {
    onClick: function onClick(e) {
      e.preventDefault();
      var link = e.target.getAttribute("href");
      if (link) router.push(link);
      setText(infoText);
    },
    as: "p",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), (0, _hasStoreAdditionalFunctionalities["default"])(language) && __jsx(_Box["default"], {
    sx: {
      display: "flex",
      mt: 20,
      a: {
        color: "main",
        textDecoration: "underline",
        font: "xs"
      }
    }
  }, __jsx(Link, {
    href: "/info/privacy"
  }, __jsx(_LinkRaw["default"], {
    title: "Datenschutzerklärung"
  }, "Datenschutzerklärung")), __jsx(_Box["default"], {
    sx: {
      margin: "2px 10px 0 10px",
      height: 15,
      borderLeftStyle: "solid",
      borderLeftColor: "black",
      borderLeftWidth: "1px"
    }
  }), __jsx(Link, {
    href: "/info/impressum"
  }, __jsx(_LinkRaw["default"], {
    title: "Impressum"
  }, "Impressum")))), __jsx(_Box["default"], {
    sx: {
      textAlign: "right",
      display: "flex",
      flexDirection: ["column", "row", null, "column", null, null],
      alignItems: ["center", null, "stretch"],
      justifyContent: "center",
      mt: ["s8", null, null, "s0", null, null]
    }
  }, confirmButtonDisplay, manageOptionsButtonLabel && manageButtonDisplay));
};
var _default = CookieNotice;
exports["default"] = _default;